import { z } from "zod";

/**
 * Portal dates are timezone-less calendar days: the backend converts
 * `YYYY-MM-DD` into midnight in `CommonDestinationTimezone`.
 */
export const portalDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be formatted as YYYY-MM-DD");

/** Same pattern as the server's `strictDecimalString`. Strings in, strings out (never floats). */
export const strictDecimalString = z
  .string()
  .regex(/^-?(0|[1-9]\d*)(\.\d+)?$/, "Enter a number like 0.05");
